let gaode_map_config = {
    Key: "2e173413ba0fd0b71b9599af22c17775",
    safeKey: "1be85d949ded5bfe0eb123551111a4ad"
};

export { gaode_map_config };
